import { ValidatorFn, Validators } from '@angular/forms';

export interface IFieldConstraint {
    required?: boolean;
    maxLength?: number;
    minLength?: number;
}

export function validatorsFromConstraint(constraint?: IFieldConstraint): ValidatorFn[] {
    if (!constraint) return [];

    const validators: ValidatorFn[] = [];
    if (constraint.required) validators.push(Validators.required);
    if (constraint.maxLength != null) validators.push(Validators.maxLength(constraint.maxLength));
    if (constraint.minLength != null) validators.push(Validators.minLength(constraint.minLength));

    return validators;
}
